// src/App.js
import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Home from './components/Home'
import OurStory from './components/OurStory'
import TheFarm from './components/TheFarm'
import Experiences from './components/Experiences'
import PlanYourJourney from './components/PlanYourJourney'
import Stays from './components/Stays'
import RoomDetail from './components/RoomDetail'
import Contact from './components/Contact'
import Gallery from './components/Gallery'
import 'bootstrap/dist/css/bootstrap.min.css'
import './App.css'
import ScrollToTop from './components/scrollTop'

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className='App'>
        <Navbar />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/our-story' element={<OurStory />} />
          <Route path='/the-farm' element={<TheFarm />} />
          <Route path='/experiences' element={<Experiences />} />
          <Route path='/plan-your-journey' element={<PlanYourJourney />} />
          <Route path='/stays' element={<Stays />} />
          <Route path='/stays/:id' element={<RoomDetail />} />
          <Route path='/gallery' element={<Gallery />} />
          <Route path='/contact' element={<Contact />} />
        </Routes>
      </div>
    </Router>
  )
}

export default App
